"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.propTypes = exports.defaultProps = exports.default = exports.ActionGroups = void 0;
require("./ActionGroups.css");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _react = _interopRequireDefault(require("react"));
var _ActionGroupDefault = _interopRequireDefault(require("../ActionGroupDefault/ActionGroupDefault"));
var _ActionGroupMulti = _interopRequireDefault(require("../ActionGroupMulti/ActionGroupMulti"));
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
/**
 * ActionGroups component
 *
 * @method
 * @param { ActionGroupsProps} props
 * @returns ActionGroups
 */

const ActionGroups = props => {
  const {
    variant,
    actions,
    style,
    types,
    alignment = defaultProps.alignment,
    fullyClickableParent,
    isKnockoutLink
  } = props;
  if (!actions && !variant) {
    return null;
  }

  // Checks the variant to determine which ActionGroup to display
  const isActionGroupDefault = variant === 'default';
  const isActionGroupMulti = variant === 'multi';
  return /*#__PURE__*/_react.default.createElement(_react.default.Fragment, null, isActionGroupDefault && /*#__PURE__*/_react.default.createElement(_ActionGroupDefault.default, {
    action1: actions[0],
    action2: actions[1],
    fullyClickableParent: fullyClickableParent,
    isKnockoutLink: isKnockoutLink,
    style: style,
    type: types
  }), isActionGroupMulti && /*#__PURE__*/_react.default.createElement(_ActionGroupMulti.default, {
    actions: actions,
    alignment: alignment,
    fullyClickableParent: fullyClickableParent,
    isKnockoutLink: isKnockoutLink,
    style: style,
    types: types
  }));
};

/**
 * Property type definitions
 * @typedef ActionGroups
 * @type {object}
 * @property {array} actions - allows passing an array of actions
 * @property {string} alignment - sets the actions to centered
 * @property {string} buttonStyle - sets the button style for ActionGroups
 * @property {boolean} isKnockoutLink - sets the link text to white
 * @property {string} linkStyle - sets the link style for ActionGroups
 * @property {string} style - sets the style of the ActionGroups
 * @property {string} types - sets the types of the ActionGroups
 * @property {string} variant - sets the variant of the ActionGroups
 */
exports.ActionGroups = ActionGroups;
const propTypes = exports.propTypes = {
  /**
   * Allows passing an array of actions
   */
  actions: _propTypes.default.array,
  /**
   * Sets the actions to centered
   */
  alignment: _propTypes.default.string,
  /**
   * Sets the link text to white
   */
  isKnockoutLink: _propTypes.default.bool,
  /**
   * sets the style of the ActionGroups
   */
  style: _propTypes.default.string,
  /**
   * type component above the eyebrow
   */
  types: _propTypes.default.string,
  /**
   * sets the variant of the ActionGroups
   */
  variant: _propTypes.default.string
};

/**
 * Default values for passed properties
 *
 * @type {object}
 * @property {string} alignment - alignment: 'left' - sets the default for the alignment
 */
const defaultProps = exports.defaultProps = {
  alignment: 'left'
};
ActionGroups.propTypes = propTypes;
var _default = exports.default = ActionGroups;